export default class filters {
    constructor(){
      this.checkFilters = this.checkFilters.bind(this);
      this.init();
    }
    
    init(){
        const par = this;
        
        $('.filters ul > span').on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass('open');
        });
        
        $('button.toggle-filters').on('click', function(e){
            e.preventDefault();
            $('.filters').toggleClass('out');
        });
        
        $('.filters .clear').off('click').on('click', function(e){
            $(this).closest('.filters').find('input:not([data-name="categorys"])').prop('checked', false);
            $(this).closest('.filters').find('input').first().trigger('change');
            $('.filters input.search').val(''); // Clear search input
            par.checkFilters();
        });
        
        $('.filters label').on('click', function(e){
            if($(e.target).is('label')) {
                e.preventDefault();
                e.stopPropagation();
                $(this).find('input').prop('checked', !$(this).find('input').prop('checked')).trigger('change');
            }
            par.checkFilters();
        });
        
        $('.filters input').on('change', function(){
            par.checkFilters();
        });
        
        $('.filters input[type="radio"]').off('change').on('change', function() {
            $('.filters input[type="radio"][data-name="' + $(this).attr('data-name') + '"]').not(this).prop('checked', false);
            par.checkFilters();
        });

        // Search input on keyup
        $('.filters input.search').on('keyup', function() {
            par.checkFilters();
        });
        
        par.checkFilters();
    }
   
    checkFilters() {
        let filters = $('.filters input:checked');
        let searchText = $('.filters input.search').length > 0 ? $('.filters input.search').val().toLowerCase() : null;
        
        $('.product-item').hide();
        
        $('.product-item').each(function() {
            let item = $(this);
            let isMatch = true;
            
            // Checkbox filters
            filters.each(function() {
                let filterType = $(this).attr('data-name');
                let filterValue = $(this).attr('data-filter');
                
                if ($(this).attr('type') === 'radio' && !$(this).is(':checked')) {
                    return true;
                }
                
                if (filterType === 'price') {
                    let [min, max] = $(this).attr('data-price').split('–').map(Number);
                    let itemPrice = parseInt(item.attr('data-price'));
                    if (itemPrice < min || itemPrice > max) isMatch = false;
                } else if (filterType === 'size') {
                    let ind = item.attr('data-size_category').indexOf(filterValue);
                    if ((item.attr('data-size_category') && (ind == -1 || ind >= 1)) || !item.attr('data-size_category')) {
                        isMatch = false; // Does not match the size
                    }
                // } else if (filterType === 'size' && (!item.attr('data-size_category') || item.attr('data-size_category').indexOf(filterValue) < 0)) {
                    // isMatch = false;
                } else if (filterType === 'autographed' && (!item.attr('data-autographed') || item.attr('data-autographed').indexOf('yes') < 0)) {
                    isMatch = false;
                } else if (filterType === 'ready_to_hang' && (!item.attr('data-ready_to_hang') || item.attr('data-ready_to_hang').indexOf('yes') < 0)) {
                    isMatch = false;
                } else if (filterType === 'techniques' && (!item.attr('data-technique') || item.attr('data-technique').indexOf(filterValue) < 0)) {
                    isMatch = false;
                } else if (filterType === 'categorys' && (!item.attr('data-category') || item.attr('data-category').indexOf(filterValue) < 0)) {
                    isMatch = false;
                } else if (filterType === 'themes' && (!item.attr('data-themes') || item.attr('data-themes').indexOf(filterValue) < 0)) {
                    isMatch = false;
                }
            });
            
            // Text search filtering
            if (searchText && searchText.length > 0) {
                let itemText = item.text().toLowerCase();
                if (!itemText.includes(searchText)) {
                    isMatch = false;
                }
            }
            
            if (isMatch) {
                item.show();
            }
        });
    }
}
